import { COUNTRIES } from 'shared/metrics/constants';

export const PLACEMENT_QUALITY_TYPES = [
  { name: 'Premium', status: 'premium', vehiclePower: 'A' },
  { name: 'Prominent', status: 'prominent', vehiclePower: 'B' },
  { name: 'Standard', status: 'standard', vehiclePower: 'C' },
  { name: 'Ungraded', status: 'ungraded', vehiclePower: 'C' },
];

export const PLACEMENT_STATUSES_DISPLAY_MAP = {
  draft: 'Draft',
  internalReview: 'Internal Review',
  published: 'Live / Published',
  deleted: 'Deleted',
};

export const PLACEMENT_TRADITIONAL_STATUSES_DISPLAY_MAP = {
  draft: 'Draft',
  internalReview: 'In Review',
  published: 'Published',
  deleted: 'Deleted',
};

// New PlacedBy and Method options (replacing Type and Source)
export const PLACED_BY_SELECT_OPTIONS = [
  { label: 'BEN', value: 'BEN' },
  { label: 'Unknown', value: 'Unknown' },
];

export const METHOD_SELECT_OPTIONS = [
  { label: 'Paid', value: 'Paid' },
  { label: 'Propped', value: 'Propped' },
  { label: 'Unknown', value: 'Unknown' },
];

export const METHOD_SELECT_FILTER_OPTIONS = METHOD_SELECT_OPTIONS;

export const STORY_TYPE_SELECT_OPTIONS = [
  { label: 'Scripted', value: 'scripted' },
  { label: 'Unscripted', value: 'unscripted' },
];

export const VERBALS_SELECT_OPTIONS = [
  { label: 'Mentioned', value: 'mentioned' },
  { label: 'Only', value: 'only' },
];

export const SOURCE_CLASS_SELECT_OPTIONS = [
  { label: 'Video', value: 'video' },
  { label: 'Social', value: 'social' },
  { label: 'Press', value: 'press' },
];

export const PLACEMENT_QUALITY_TYPES_SELECT_OPTIONS = PLACEMENT_QUALITY_TYPES.map(
  (type) => ({
    value: type.status,
    label: type.name,
  }),
).concat([{ value: 'msft x', label: 'MSFT X' }]);

export const PLACEMENT_STATUSES = Object.keys(
  PLACEMENT_STATUSES_DISPLAY_MAP,
).sort();

export const PLACEMENT_STATUS_SELECT_OPTIONS = PLACEMENT_STATUSES.map(
  (status) => ({
    value: status,
    label: PLACEMENT_STATUSES_DISPLAY_MAP[status],
  }),
);

export const PLACEMENT_TRADITIONAL_STATUSES = Object.keys(
  PLACEMENT_TRADITIONAL_STATUSES_DISPLAY_MAP,
);

export const PLACEMENT_TRADITIONAL_STATUS_SELECT_OPTIONS = PLACEMENT_TRADITIONAL_STATUSES.map(
  (status) => ({
    value: status,
    label: PLACEMENT_TRADITIONAL_STATUSES_DISPLAY_MAP[status],
  }),
);

export const PLACEMENT_SORT_FIELDS = [
  {
    name: 'relevance',
    label: 'Relevance',
    from: 'Z',
    to: 'A',
    defaultDirection: 'desc',
    hideSort: true,
  },
  {
    name: 'name',
    label: 'Production Name',
    from: 'A',
    to: 'Z',
    defaultDirection: 'asc',
  },
  {
    name: 'quality',
    label: 'Quality',
    from: 'Low',
    to: 'High',
    defaultDirection: 'desc',
  },
  {
    name: 'premiereDate',
    label: 'Premiere Date',
    from: 'Oldest',
    to: 'Newest',
    defaultDirection: 'asc',
  },
  {
    name: 'createdAt',
    label: 'Created Date',
    from: 'Oldest',
    to: 'Newest',
    defaultDirection: 'desc',
  },
  {
    name: 'lastEdit',
    label: 'Last edit',
    from: 'Oldest',
    to: 'Newest',
    defaultDirection: 'desc',
  },
  {
    name: 'episodeNumber',
    label: 'Season/Episode',
    from: 'Low',
    to: 'High',
    defaultDirection: 'asc',
  },
];

export const PLACEMENT_ATTRIBUTES = [
  {
    label: 'Appropriateness & Believability',
    key: 'appropriatenessBelievability',
    group: 'quality',
  },
  {
    label: 'Hands on Usage',
    key: 'handsOnUsage',
    group: 'quality',
    children: [
      {
        label: 'Plus Consumption',
        key: 'plusConsumption',
        parent: 'handsOnUsage',
        group: 'quality',
      },
    ],
  },
  {
    label: 'Showcase Product Features',
    key: 'showcaseProductFeatures',
    group: 'quality',
  },
  {
    label: 'Visibility of Product and Logo',
    key: 'visibilityProductLogo',
    group: 'quality',
    children: [
      {
        label: 'Signage',
        key: 'signage',
        parent: 'visibilityProductLogo',
        group: 'quality',
      },
      {
        label: 'Set Dressing (i.e. Bar Tap/Bar Back)',
        key: 'setDressing',
        parent: 'visibilityProductLogo',
        group: 'quality',
      },
      {
        label: 'Packaging',
        key: 'packaging',
        parent: 'visibilityProductLogo',
        group: 'quality',
      },
      {
        label: 'Product (I.E. Bottle/Can) ',
        key: 'productBottleCan',
        parent: 'visibilityProductLogo',
        group: 'quality',
      },
    ],
  },
  {
    label: 'Verbal Mention',
    key: 'verbalMention',
    group: 'quality',
  },
  {
    label: 'Storyline Integration',
    key: 'storylineIntegration',
    group: 'quality',
  },
  {
    label: 'Implied Celebrity Endorsement',
    key: 'impliedCelebrityEndorsement',
    group: 'quality',
  },
  {
    label: 'Positive Brand Message',
    key: 'positiveBrandMessage',
    group: 'quality',
  },
  {
    label: 'Minimum Duration',
    key: 'minimumDuration',
    group: 'quality',
  },
  {
    label: 'Brand Safety',
    key: 'brandSafety',
    group: 'quality',
    children: [
      {
        label: 'Underage drinking',
        key: 'underageDrinking',
        parent: 'brandSafety',
        group: 'quality',
      },
      {
        label: 'Overconsumption',
        key: 'overconsumption',
        parent: 'brandSafety',
        group: 'quality',
      },
      {
        label: 'Illegal Substances involved',
        key: 'illegalSubstancesInvolved',
        parent: 'brandSafety',
        group: 'quality',
      },
      {
        label: 'Crime & Illegal activity',
        key: 'crimeIllegalActivity',
        parent: 'brandSafety',
        group: 'quality',
      },
      {
        label: 'Operating a vehicle or heavy machinery',
        key: 'operatingVehicleOrHeavyMachinery',
        parent: 'brandSafety',
        group: 'quality',
      },
    ],
  },
  {
    label: 'Reel Ready',
    key: 'reelReady',
    group: 'attributes',
  },
  {
    label: 'Media Spend',
    key: 'mediaSpend',
    group: 'attributes',
  },
  {
    label: 'Added Value',
    key: 'addedValue',
    group: 'attributes',
  },
];

export const PLACEMENT_QUALITY_ATTRIBUTE = PLACEMENT_ATTRIBUTES.filter(
  (attr) => attr.group === 'quality',
);

export const PLACEMENT_COUNTRY_SELECT_OPTIONS = COUNTRIES;

export const FILTER_ID = 'placementsList';

export const PLACED_BY_DISPLAY_MAP = {
  BEN: 'BEN',
  Unknown: 'Unknown',
};

export const METHOD_DISPLAY_MAP = {
  Paid: 'Paid',
  Propped: 'Propped',
  Unknown: 'Unknown',
};

export const SINGLE_VIEW_FIELDS_STORAGE_KEY = '$BEN$--placementSearchFilter';
export const SHOW_FIELDS_LABEL_KEY = '__label';

export const VIEW_CURRENCY_LOCALE = { style: 'currency', currency: 'USD' };

export const tooltips = {};
